import { setThumbnails } from '@/redux/ducks/document/thumbnails'
import store from '@/redux/store'
import axios from 'axios'
import { withDmsFrontendToken } from '@/modules/file/_helpers/dms-authenticated-request'

export interface Thumbnail {
  url?: string,
  state?: string,
}

export interface ThumbnailCollection {
  minioId: string,
}

class ThumbnailService {
  private thumbnails: ThumbnailCollection[] = []

  async fetch(minioId, size = 200, force = false): Promise<Thumbnail> {
    const tenantSettings = store.getState().tenant.settings
    const { dmsThumbnailUrl } = tenantSettings

    if (!dmsThumbnailUrl) return

    let thumbnail = this.thumbnails.find((thumbnail) => thumbnail.minioId === minioId)

    const doFetch = !thumbnail || (thumbnail?.[size]?.state !== 'fetching'
      && (thumbnail[size]?.state === 'creating' || !thumbnail[size]?.state || force)
    )
    if (!doFetch) return thumbnail[size]

    if (!thumbnail) {
      thumbnail = { minioId, [size]: { url: '', state: 'fetching' } }
      this.thumbnails.push(thumbnail)
    }

    const timeout = thumbnail[size]?.state === 'creating'
      ? 2000
      : 0

    return new Promise((resolve, reject) => {
      setTimeout(async() => {
        let state = 'creating'
        let url = ''
        try {
          const { data, headers } = await withDmsFrontendToken(({ dmsToken, dmsApiClient }) => axios.post(
            dmsThumbnailUrl,
            {
              minioId,
              size,
            },
            {
              headers: {
                Authorization: `Bearer ${dmsToken}`,
                'Api-Client': dmsApiClient,
                'Content-Type': 'application/json',
              },
              responseType: 'blob',
            },
          ))
          state = headers['thumbnail-status']
          url = window.URL.createObjectURL(data)
        } catch (e) {
          state = 'failed'
          reject(e)
        }

        if (thumbnail) {
          thumbnail = { ...thumbnail, [size]: { url, state } }
        } else {
          thumbnail = {
            minioId,
            [size]: { url, state },
          }
        }

        this.thumbnails = this.thumbnails.filter(({ minioId }) => minioId !== thumbnail.minioId)
        this.thumbnails.push(thumbnail)

        store.dispatch(setThumbnails(this.thumbnails))

        resolve(thumbnail[size])
      }, timeout)

    })
  }

  getThumbnail(minioId: string, size = 200): string {
    const thumb = this.thumbnails.find(thumbnail => thumbnail.minioId === minioId)
    if (!thumb || !thumb[size]) return ''
    return thumb[size]
  }

  clear(): void {
    this.thumbnails = []
  }

  invalidate(minioId: string): void {
    this.thumbnails = this.thumbnails.filter((thumbnail) => thumbnail.minioId !== minioId)
  }
}

export default new ThumbnailService()
